const Influencers = () => import('@/pages/publicity/influencers/InfluencerList.vue');
const AddInfluencer = () => import('@/pages/publicity/influencers/AddInfluencer.vue');
const EditInfluencer = () => import('@/pages/publicity/influencers/EditInfluencer.vue');

const influencerRoutes = [
    {
        path: 'influencers',
        name: 'PublicityInfluencers',
        component: Influencers,
        meta: {
            menu: true,
            title: 'Influencers',
            permissionsAnyOf: ['Permissions.Publicity.Influencers.Search'],
        },
    },
    {
        path: 'first-contacts/add',
        name: 'PublicityInfluencersAdd',
        component: AddInfluencer,
    },
    {
        path: 'first-contacts/edit/:id',
        name: 'PublicityInfluencersEdit',
        component: EditInfluencer,
    },
];

export default influencerRoutes;
